import { buildSvgString, type SvgStringOpts } from '../../svgString';

import { data } from './data';

export const TextFieldSVG = (opts?: SvgStringOpts): string => buildSvgString(data, opts);

export default TextFieldSVG;
